import { Icons } from '@/assets/icons/icons';

import type { FeedPillIcon, FeedRowView } from './feedRowView';
import type { ComponentType } from 'react';

const PILL_ICON: Record<FeedPillIcon, ComponentType<{ className?: string }>> = {
  acknowledge: Icons.check,
  add: Icons.plus,
  approve: Icons.check,
  assign: Icons.userPlus,
  close: Icons.circleX,
  comment: Icons.newChat,
  complete: Icons.check,
  delete: Icons.trash2,
  merge: Icons.merge,
  move: Icons.arrowRightLeft,
  pull_request: Icons.gitPullRequest,
  react: Icons.smilePlus,
  reopen: Icons.restore,
  rsvp: Icons.calendar,
  schedule: Icons.calendarClock,
  send: Icons.newChat,
  update: Icons.pencil,
};

/**
 * The row's Chat button. Once the user has started a chat from the card, it continues that chat, as a to-do's
 * Continue working does
 */
export const chatActionOf = (
  title: string,
  chatLabel: string,
  chatStarted: boolean
) =>
  chatStarted
    ? {
        icon: Icons.chevronsRight,
        label: 'Continue working',
        accessibleLabel: `Continue working on ${title}`,
      }
    : {
        icon: Icons.newChat,
        label: chatLabel,
        accessibleLabel: `${chatLabel} about ${title}`,
      };

export const ctaIconOf = (
  pill: NonNullable<FeedRowView['pill']>,
  kindIcon: ComponentType<{ className?: string }>
) => {
  if (pill.press.kind === 'chat') return Icons.sparkles;
  if (pill.press.kind === 'continue') return Icons.chevronsRight;
  if (pill.press.kind === 'acknowledge') return Icons.check;
  if (pill.icon === 'send' || pill.icon === null)
    return kindIcon === Icons.info ? Icons.newChat : kindIcon;
  return PILL_ICON[pill.icon];
};
